import { render, staticRenderFns } from "./PageLayoutNine.vue?vue&type=template&id=236bc9c0&"
import script from "./PageLayoutNine.vue?vue&type=script&lang=js&"
export * from "./PageLayoutNine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports